namespace Areas.Maintenance.List {
    "use strict";

    var projectMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["AccountMilestoneType", "AccountProgramType", "EthnicityType", "LRDPZone", "ProjectType",
            "ProjectTypeDetail", "ProjectTypeTree", "RoleType", "StatusGroup", "Status"])

    var fundMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["FundingSourceType", "FundingSource", "FundTransferAuthorizedVia", "FundTransferType"])

    var accountCIBMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["AccountCIBStatus", "PWCFund"])

    var budgetMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["BudgetCategory", "BudgetCategoryGroup", "UCOPSubCode"])

    var constructionManagementMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["SubmittalStatus", "MeetingMinutesStatus", "ProfileStatus", "PunchListStatus", "WarrantyStatus",
            "ProfileType"])

    var contractorPayMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["RetentionType", "ContractScheduleValueType", "ContractScheduleValueAction"])

    var generalLedgerMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["GLActivityType", "GLDataGroup", "GLLinearMonth", "GLTypeEntry", "GLFiscalYear"])

    var changeManagementMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["ChangeManagementReason", "ChangeManagementStatus", "ChangeManagementType"])

    var systemMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["AuthorizedUser", "SystemConfigSettings", "SystemUsers"])

    var recordRetentionMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["RecordsRetentionSubCategory"])

    var vendorMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["VendorClassificationType"])

    var peopleMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["ContactPhoneType"])

    var accountScheduleMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["Phase", "SubPhase", "AccountScheduleType", "AccountScheduleStatus"])


    export function projectMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(projectMaintenanceTabItems)(params);
    }

    export function fundMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(fundMaintenanceTabItems)(params);
    }

    export function accountCIBMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(accountCIBMaintenanceTabItems)(params);
    }

    export function budgetMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(budgetMaintenanceTabItems)(params);
    }

    export function constructionManagementMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(constructionManagementMaintenanceTabItems)(params);
    }

    export function contractorPayMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(contractorPayMaintenanceTabItems)(params);
    }

    export function generalLedgerMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(generalLedgerMaintenanceTabItems)(params);
    }

    export function changeManagementMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(changeManagementMaintenanceTabItems)(params);
    }

    export function systemMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(systemMaintenanceTabItems)(params);
    }

    export function recordRetentionMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(recordRetentionMaintenanceTabItems)(params);
    }

    export function peopleMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(peopleMaintenanceTabItems)(params);
    }

    export function vendorMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(vendorMaintenanceTabItems)(params);
    }
    
    export function accountScheduleMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(accountScheduleMaintenanceTabItems)(params);
    }
}